import { useState, useEffect } from "react";
import { Place } from "../types/place";
import { getAllPlaces } from "../services/placeService";

export const usePlacesData = (
  t: (key: string) => string,
  getImgs: boolean = false
): { places: Place[]; loading: boolean } => {
  const [places, setPlaces] = useState<Place[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;
    setLoading(true);

    getAllPlaces(t, getImgs)
      .then((data) => {
        if (!isMounted) return;

        const result = getImgs ? [...data].reverse() : data;
        setPlaces(result);
      })
      .finally(() => {
        if (isMounted) setLoading(false);
      });

    return () => {
      isMounted = false;
    };
  }, [getImgs, t]);
  return { places, loading };
};
